export class CompiledTotalAdvancedDailyEngagedUserConsumption {
  dailyEngagedUsersTotal!: number;
  userConversationTotal!: number;
  prospectConversationTotal!: number;
  activeMessageTotal!: number;
  dailyEngagedUserAITotal!: number;

  constructor(compiledTotalAdvancedDailyEngagedUserConsumption: Partial<CompiledTotalAdvancedDailyEngagedUserConsumption> | null) {
    Object.assign(this, compiledTotalAdvancedDailyEngagedUserConsumption);
  }
}
